import { Link } from 'react-router-dom';
import { FaFacebookF, FaTwitter, FaYoutube, FaLinkedinIn } from 'react-icons/fa';
import {
  COMPANY_ADDRESS,
  COMPANY_NAME,
  SITE_DOMAIN,
  SITE_URL,
  SUPPORT_EMAIL,
  SUPPORT_PHONE_DISPLAY,
  SUPPORT_PHONE_TEL,
} from '../constants/site';

function Footer() {
  return (
    <footer className="ftm-footer">
      <div className="ftm-footer-grid">
        <div>
          <h3>About Us</h3>
          <p>
            Independent how-to guides and support information for Family Tree Maker users. We are not affiliated with
            any software vendor unless clearly stated.
          </p>
        </div>
        <div>
          <h3>Services</h3>
          <ul>
            <li>
              <a href="/#home">Installation &amp; setup</a>
            </li>
            <li>
              <a href="/#guides">Migration &amp; transfer</a>
            </li>
            <li>
              <a href="/#issues">Troubleshooting</a>
            </li>
            <li>
              <a href="/#requirements">System requirements</a>
            </li>
          </ul>
        </div>
        <div>
          <h3>Support</h3>
          <p>
            <strong>{COMPANY_NAME}</strong>
            <br />
            {COMPANY_ADDRESS}
            <br />
            <a href={`tel:${SUPPORT_PHONE_TEL}`}>{SUPPORT_PHONE_DISPLAY}</a>
            <br />
            <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>
          </p>
        </div>
        <div>
          <h3>Social Media</h3>
          <div className="ftm-social">
            <a href="https://facebook.com/" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
              <FaFacebookF />
            </a>
            <a href="https://twitter.com/" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
              <FaTwitter />
            </a>
            <a href="https://youtube.com/" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
              <FaYoutube />
            </a>
            <a href="https://linkedin.com/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
              <FaLinkedinIn />
            </a>
          </div>
          <ul style={{ marginTop: '1rem' }}>
            <li>
              <Link to="/privacy-policy">Privacy Policy</Link>
            </li>
            <li>
              <Link to="/terms-and-conditions">Terms &amp; Conditions</Link>
            </li>
            <li>
              <Link to="/refund-policy">Refund Policy</Link>
            </li>
          </ul>
        </div>
      </div>
      <div className="ftm-footer-disclaimer">
        <p>
          <strong>Disclaimer:</strong> This site provides general information and independent how-to guidance for people
          using Family Tree Maker–style genealogy workflows. We are not the publisher of Family Tree Maker software, and
          we do not represent or warrant third-party products. Phone and email support relate to the services described
          on this site only. Always keep your own backups before upgrades or file moves; results can vary by system and
          version.
        </p>
      </div>
      <div className="ftm-footer-bottom">
        <p>
          © {new Date().getFullYear()} {SITE_DOMAIN}. Website{' '}
          <a href={SITE_URL} target="_blank" rel="noopener noreferrer" style={{ color: 'inherit' }}>
            {SITE_URL}
          </a>{' '}
          operated by {COMPANY_NAME}. Reference-only use of trademarks.
        </p>
      </div>
    </footer>
  );
}

export default Footer;
